let routerInstance = null;
export function setRouter(router) {
    routerInstance = router;
}
export function getRouter() {
    if (!routerInstance) {
        throw new Error("Router has not been registered. Call setRouter() during app initialization.");
    }
    return routerInstance;
}
